module.exports = __webpack_public_path__ + "static/media/VoluntHere.350f222c.webp";